module.exports = __webpack_public_path__ + "static/img/camera-control-close.116de968.svg";